import { render, staticRenderFns } from "./RecenteLoading.vue?vue&type=template&id=52646740&scoped=true&"
import script from "./RecenteLoading.vue?vue&type=script&lang=js&"
export * from "./RecenteLoading.vue?vue&type=script&lang=js&"
import style0 from "./RecenteLoading.vue?vue&type=style&index=0&id=52646740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52646740",
  null
  
)

export default component.exports